import { render, staticRenderFns } from "./CallRecordCard.vue?vue&type=template&id=6f28b667&scoped=true&"
import script from "./CallRecordCard.vue?vue&type=script&lang=js&"
export * from "./CallRecordCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f28b667",
  null
  
)

export default component.exports